import React, { createContext, useContext } from 'react'
import type { Style } from '../types/style.types'

export interface StyleContextValue {
  // Current computed style (result of merging hierarchy)
  style: Style | null
  
  // Individual style sources for debugging/reference
  eventStyle?: Style | null
  teamStyle?: Style | null
  pageStyle?: Style | null
  
  // Helper to check if a specific property is set
  hasStyleProperty: (property: keyof Style) => boolean
  
  // Get the source of a style property (event, team, or page)
  getStyleSource: (property: keyof Style) => 'event' | 'team' | 'page' | null
}

const StyleContext = createContext<StyleContextValue | undefined>(undefined)

export const useStyle = () => {
  const context = useContext(StyleContext)
  if (!context) {
    throw new Error('useStyle must be used within a StyleProvider')
  }
  return context
}

export default StyleContext